import * as htmlToImage from 'html-to-image';
import { useCallback, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import useGetGeneralAppData from '../../../../../hooks/useGetGeneralAppData';
import { MappedVehicleType } from '../../types';

export default function useQrCodes() {
  const [vehicleQrCodeBeingShow, setVehicleQrCodeBeingShow] = useState<MappedVehicleType>({} as MappedVehicleType);
  const [vehicleQrCodeModalShow, setVehicleQrCodeModalShow] = useState(false);
  const [isDownloadingQrCode, setIsDownloadingQrCode] = useState(false);
  const qrCodeRef = useRef<HTMLDivElement | null>(null);

  const [allQrCodesModalShow, setAllQrCodesModalShow] = useState(false);
  const [areQrCodesDownloading, setAreQrCodesDownloading] = useState(false);
  const allQrCodesRef = useRef<HTMLDivElement | null>(null);

  const { companyName } = useGetGeneralAppData();

  const downloadAllQrCodes = useCallback(async () => {
    if (!allQrCodesRef) {
      return;
    }
    setAreQrCodesDownloading(true);
    const dataUrl = await toast.promise(htmlToImage.toSvg(allQrCodesRef.current as HTMLDivElement, {
      backgroundColor: '#fff',
    }), {
      pending: 'Aguarde enquanto os QR Codes são baixados',
      success: 'Os QR Codes foram baixados!',
      error: 'Não foi possível baixar os QR Codes'
    });
    // download image
    const link = document.createElement('a');
    link.download = `QR Codes veículos ${companyName}.svg`;
    link.href = dataUrl;
    link.click();
    link.remove();
    setAreQrCodesDownloading(false);
    setAllQrCodesModalShow(false);
  }, [companyName]);

  const downloadQrCode = useCallback(async () => {
    if (!qrCodeRef) {
      return;
    }
    setIsDownloadingQrCode(true);
    const dataUrl = await toast.promise(htmlToImage.toSvg(qrCodeRef.current as HTMLDivElement, {
      backgroundColor: '#fff',
    }), {
      pending: 'Aguarde enquanto o QR Code é baixado',
      success: 'O QR Code foi baixado!',
      error: 'Não foi possível baixar o QR Code'
    });
    // download image
    const link = document.createElement('a');
    link.download = `QR Codes veículos ${companyName}.svg`;
    link.href = dataUrl;
    link.click();
    link.remove();
    setIsDownloadingQrCode(false);
    setVehicleQrCodeModalShow(false);
  }, [companyName]);

  function handleOpenVehicleQrCodeModal(vehicle: MappedVehicleType) {
    setVehicleQrCodeBeingShow(vehicle);
    setVehicleQrCodeModalShow(true);
  }

  return {
    vehicleQrCodeBeingShow,
    vehicleQrCodeModalShow,
    isDownloadingQrCode,
    allQrCodesModalShow,
    areQrCodesDownloading,
    downloadAllQrCodes,
    downloadQrCode,
    handleOpenVehicleQrCodeModal,
    setAllQrCodesModalShow,
    setVehicleQrCodeModalShow,
    allQrCodesRef,
    qrCodeRef,
  };
}
